module.exports = __webpack_public_path__ + "static/media/ZP4.a568062d.pdf";